import { AutomationsAccessLevel, useFeatureAutomations } from "@/hooks/use-feature-automations";
import { LoadingState } from "@/components/podkit/loading/LoadingState";
import { Navigate } from "react-router-dom";
import type { FC, PropsWithChildren } from "react";

/**
 * Redirects to home if the user does not have full automation access.
 * Used to guard sub-routes like /automations/new, /automations/:workflowId, etc.
 */
export const RequireFullAutomationAccess: FC<PropsWithChildren> = ({ children }) => {
    const { accessLevel, isLoading } = useFeatureAutomations();

    if (isLoading) {
        return <LoadingState />;
    }

    if (accessLevel !== AutomationsAccessLevel.Full) {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};
